import _ from 'underscore';

import { PSSA_CLUB_ID } from '@pssa/common';
import { IResult } from '@pssa/types';

interface ITableResult {
  classId: string;
  className: string;
  competitor: string;
  competitorId: string;
  isVisitor: boolean;
  points: number | null;
  resultId: string;
  row: number;
  score: string;
}

const isVisitor = (club: string) => club !== 'PSSA' && club !== PSSA_CLUB_ID;

export const resultMapper = (r: IResult, i: number): ITableResult => ({
  classId: r.classId,
  className: r.class,
  competitor: `${r.competitor}${isVisitor(r.club) ? ` (${r.club})` : ''}`,
  competitorId: r.personId,
  isVisitor: isVisitor(r.club),
  points: r.rank > 0 ? r.rank : null,
  resultId: r._id,
  row: i + 1,
  score: r.points ? parseFloat(r.score).toFixed(2) : 'NSR',
});

export function resultsHelper(results: IResult[]): ITableResult[] {
  const scoreSorted = results.sort((a, b) => parseFloat(b.score) - parseFloat(a.score));

  // group the results by class
  const rankedResults = _.groupBy(_.sortBy(scoreSorted, 'class'), 'class');

  // mutate the objects rank to apply scores
  Object.keys(rankedResults).map((key) => {
    let MAX_POINTS = 10;
    return rankedResults[key].forEach((result: IResult) => {
      if (result.club === 'PSSA' && result.points > 0 && MAX_POINTS > 0) {
        result.rank = --MAX_POINTS + 1;
      } else {
        result.rank = 0;
      }
    });
  });

  // flatten the object from grouped keys
  return _.flatten(Object.values(rankedResults)).map((r: IResult, i: number) => resultMapper(r, i));
}
